export const init = {
  density: "60",
  size: "20x25",
  color: "прозрачный",
  face_colors: 1,
  rear_colors: 1,
  same_print: false,
  quantity: 200,
  quantity_manual: 0,
  min_quantity: 100,
  markups: [],
};
